import { api } from "constants/RotasAPI";
import { LoadingContext } from "context/LoadingContext";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import { downloadFile } from "shared/util/functions/download/DownloadFunctions";
import { http } from "shared/util/http";
import { AnexoType } from "types/anexo/AnexoType";

export const useGetBaixarAnexoProcessoJudicial = () => {
  const { setLoading } = useContext(LoadingContext);

  const baixarAnexo = async (anexo: AnexoType) => {
    setLoading(true);
    await http
      .get(`${api.processosJudiciaisAnexos.getBytesAnexo}/${anexo.uuidBucket}`)
      .then((response) => {
        downloadFile(response.data, anexo.nome);
      })
      .catch((error) => {
        toast.error("Erro ao baixar anexo");
      })
      .finally(() => setLoading(false));
  };

  return { baixarAnexo };
};
